import { Injectable, Inject } from '@angular/core';
import { SESSION_STORAGE, StorageService } from 'angular-webstorage-service';

@Injectable({
    providedIn: 'root'
})
export class SessionService {

    public data: any = [];

    constructor(@Inject(SESSION_STORAGE) private storage: StorageService) { }

    saveInSession(key, val): void {
        this.storage.set(key, val);
        this.data[key] = this.storage.get;
    }

    getFromSession(key): any {
        return this.storage.get(key);
    }

    deleteFromSession(key): void {
        this.storage.remove(key);
    }
}
